<script setup lang="ts">
import {computed} from "vue";
import {useDataStore} from "@/store/data";
import {formatPhone} from "@/helpers/phone";

const {state} = useDataStore()
const {t, locale} = useI18n();
const contacts = computed(() => {
  return state.contacts?.records?.map((contact) => {
    return {
      title: locale.value === 'et' ? contact.fields.name_et : contact.fields.name_ru,
      value: contact.fields.value,
      type: contact.fields.type
    }
  })
});
useSeoMeta({
  title: t("seo.contacts.title"),
  description: t("seo.contacts.description"),
  ogTitle: t("seo.contacts.title"),
  ogDescription: t("seo.contacts.description"),
  titleTemplate: "%s – Cursus OÜ"
});
</script>
<template>
  <div class="container py-6 lg:py-8">
    <h1 class="font-bold text-3xl lg:text-4xl mb-6">{{ t("label.contacts") }}</h1>
    <div class="flex flex-col gap-y-6 pb-6 -ml-2 md:-ml-3">
      <template v-if="state.loading">
        <div v-for="index in 3" :key="index" class="w-fit px-2 md:px-3 py-2 flex flex-col gap-2">
          <span class="animate-pulse h-4 w-16 bg-gray-100 rounded-[6px]" />
          <span class="animate-pulse h-4 w-24 bg-gray-100 rounded-[6px]" />
        </div>
      </template>
      <template v-else>
        <a v-for="(contact, index) in contacts" :key="index" :href="contact.type === 'email' ? `mailto:${contact.value}` : `tel:${formatPhone(contact.value)}`" class="w-fit px-2 md:px-3 py-2 rounded-[8px] hover:bg-gray-50 flex flex-col leading-none gap-2">
          <span class="font-bold">{{contact.title}}</span>
          <span>{{contact.value}}</span>
        </a>
      </template>
    </div>
  </div>
</template>